import React from 'react'
import classnames from 'classnames'

import styles from './Filters.module.css'
import postData from './postData'

// get uniq list of filters from data
const filters = ['all', ...postData.reduce((p, c) => p.add(c.category), new Set())]

export default ({ setFilter, currFilter }) => (
  <div className={styles.container}>
    {filters.map((filter, idx) => (
      <>
        <span
          key={idx}
          className={classnames(styles.filter, { [styles['filter-selected']]: filter === currFilter })}
          onClick={() => setFilter(filter)}
        >
          {filter}
        </span>
        {idx !== filters.length - 1 && <span>|</span>}
      </>
    ))}
  </div>
)
